/* eslint-disable complexity */
import { useMemo } from 'react';
import { uid } from 'uid';
import type { DSComboboxT } from '../react-desc-prop-types.js';
import { MENU_OPTION_TYPES } from '../constants.js';
import { filterOptions } from '../utils/listHelper.js';
const useCorrectOptions = (propsWithDefaults: DSComboboxT.Props, inputValue: string) => {
  const { filteredOptions, allOptions, onCreate } = propsWithDefaults;

  return useMemo(() => {
    let correctAllOptions = allOptions;
    if (allOptions?.every((option) => typeof option === 'string')) {
      correctAllOptions = allOptions.map((option, index) => ({
        dsId: index.toString(),
        label: option as unknown as string,
        type: MENU_OPTION_TYPES.OPTION,
        value: option as unknown as string,
      }));
    }
    const correctFilterOptions = filteredOptions ?? filterOptions(inputValue, correctAllOptions);

    // whether oncreate is passed we add as first option the creatable action based on input value string
    if (
      onCreate &&
      inputValue &&
      correctFilterOptions.findIndex(
        (option) => option.type === MENU_OPTION_TYPES.OPTION && option.label === inputValue,
      ) === -1
    ) {
      const creatableUuid = uid();
      const creatableItem: DSComboboxT.ItemCreatableOption = {
        dsId: `creatable-${creatableUuid}`,
        label: inputValue,
        type: 'creatable',
        'aria-describedby': `aria-creatable`,
      };

      return [creatableItem, ...correctFilterOptions];
    }

    return correctFilterOptions;
  }, [filteredOptions, allOptions, onCreate, inputValue]);
};

export { useCorrectOptions };
